import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faGithub, faGoogle} from '@fortawesome/free-brands-svg-icons';
import {BaseModal, ModalCloseButton} from "./ModalBase";
import { Button } from "../ui/Button";
import {Typography} from "../ui/Typography";
import {Input} from "../ui/Input";

interface AccountLoginModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const AccountLoginModal = ({isOpen, onClose}: AccountLoginModalProps) => (
    <BaseModal
        isOpen={isOpen}
        onClose={onClose}
        containerClassName="w-[min(150vw,480px)] max-h-[min(92vh,720px)] bg-surface-950 border-surface-800 p-10"
    >
        <div 
            data-state="login"
            className="flex flex-col w-full" 
        >
            <ModalCloseButton onClose={onClose}/>
            <ModalContent/>
            <SocialLogins/>
            <Divider/>
            <Form/>
            <Footer/>
            
        </div>
    </BaseModal>
);


const ModalContent = () => {
    return (
        <div className="text-center">
            
            <Typography as="h2" variant="h2" className="sm:text-[28px] py-0">
                Welcome back
            </Typography>
            
            <Typography as="p" variant="p" className="mt-2">
                Need an account?
                <Button 
                    intent="link" 
                    className="mt-2"
                    size="small"
                >
                    Sign up for free
                </Button>
            </Typography>
            
        </div>
    );
};

const SocialLogins = () => {
    return (
        <div className="mt-8 flex flex-col sm:flex-row items-center gap-4">
            
            <Button
                intent="social"
                className="flex-1"
            >
                <FontAwesomeIcon icon={faGoogle} className="text-2xl pr-3"/>Google
            </Button>

            <Button
                intent="social"
                className="flex-1"
            >
                <FontAwesomeIcon icon={faGithub} className="text-2xl pr-3"/>Github
            </Button>
            
        </div>
    );
};

const Divider = () => {
    return (
        <div className="my-6 flex items-center gap-4">
            <hr className="flex-grow border-t border-surface-800"/>
            <Typography as="p" variant="p">
                OR
            </Typography>
            <hr className="flex-grow border-t border-surface-800"/>
        </div>
    );
};


const Form = () => {
    return (
        <form id="auth-form" className="space-y-4 text-left">
            <div>
                
                <Typography as="label" variant="label">Email Address</Typography>
                <Input
                    type="email"
                    placeholder="you@gmail.com"
                    className="w-full"
                    required
                />
                
            </div>

            <div className="relative">
                
                <Typography as="label" variant="label">Password</Typography>
                
                <Input
                    type="password"
                    placeholder="••••••••"
                    className="w-full"
                    required
                />
                
                <div className="text-left mt-2 ">
                    <Button 
                        intent="link" 
                        className="my-3"
                        size="small"
                    >
                        Forgot Password?
                    </Button>
                </div>
                
            </div>
            
            <Button 
                type="submit"
                intent="primary"
                size="large"
            >
                Log in
            </Button>
            
        </form>
    );
};


const Footer = () => {
    return (
        <p id="terms-footer" className="mt-6 text-xs text-center text-surface-300 hidden">
            By creating an account, you agree to our
            <a href="#" className="underline hover:text-[#F5F5F5]">
                Terms of Service
            </a>.
        </p>
    );
};











